import React from "react";
import { GrLinkPrevious } from "react-icons/gr";
export default function ReviewQuiz({ quizInfo, quizzes, prevStep, handleSubmit }) {
  return (
    <>
      <h3>Review Quiz</h3>
      <div className="quiz-summary">
        <h4 className="quiz-summary__title">Quiz Title: {quizInfo.title}</h4>
        <p className="quiz-summary__description">Description: {quizInfo.description}</p>
        <h4 className="quiz-sammary__questions">Questions:</h4>
        {quizzes.map((quiz, index) => (
          <div key={index} className="question-summary">
            <p className="question-summary__text">Question {index + 1}: {quiz.question}</p>
            <p className="question-summary__correct-answer">Correct Answer: {quiz.options[quiz.correctAnswer]}</p>
            <p className="question-summary__time-limit">Time Limit: {quiz.timeLimit} seconds</p>
          </div>
        ))}
      </div>

      <button type="button" className="submit-button Btn" onClick={prevStep}>
      <GrLinkPrevious />
      </button>

      <button type="submit" className="submit-button Btn">
        Submit Quiz
      </button>
    </>
  );
}